<template>
  <div class="bg-white rounded-circle p-1">
    <span
      class="fa-stack fa-1x color-primary-2 font-16 mr-1 d-flex justify-content-center"
    >
      <em class="fas fa-circle fa-stack-2x" />
      <em class="fa-stack-1x fa-inverse" :class="i" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    i: {
      type: String,
      required: true,
    },
  },
};
</script>
